<template>
  <footer class="p-3 bg-dark">
    <div class="sponsors text-start mx-auto mt-3">
      <h4>Gefördert von:</h4>
      <div class="row g-2 justify-content-center my-4 gap-3">
        <div class="col-auto">
          <a href="https://www.bmbf.de/" target="_blank" rel="noopener noreferrer"
            ><img
              loading="lazy"
              height="100px"
              width="198.45px"
              :src="bmbfLogo"
              alt="Logo des Bundesministeriums für Bildung und Forschung"
          /></a>
          <p class="fs-6">Zeitraum: Sep. 23 - Feb. 24</p>
        </div>
        <div class="col-auto">
          <a
            href="https://www.prototypefund.de/projects/bahn-vorhersage"
            target="_blank"
            rel="noopener noreferrer"
            ><img
              loading="lazy"
              height="100px"
              width="56.6167px"
              :src="prototypefundLogo"
              alt="Logo des Prototypefunds"
          /></a>
        </div>
        <a class="col-auto" href="https://sfz-bw.de/" target="_blank" rel="noopener noreferrer"
          ><img
            loading="lazy"
            height="100px"
            width="139.183px"
            :src="sfzLogo"
            alt="Logo des Schülerforschungszentrums Südwürttemberg"
        /></a>
      </div>
    </div>
    <div class="row g-2 justify-content-center">
      <div class="fw-bold mt-5 mb-2 col text-center">
        <NuxtLink class="text-reset" to="/imprint">Impressum</NuxtLink> /
        <NuxtLink class="text-reset" to="/privacy">Datenschutz</NuxtLink>
      </div>
    </div>
    <div class="row g-2">
      <span class="col text-center mb-4"
        >© 2026 Bahn-Vorhersage ist ein unabhängiger Service. Dieser steht in keiner Verbindung mit
        der Deutschen Bahn und ihren Tochter-Unternehmen.
      </span>
    </div>
    <div v-if="Capacitor.isNativePlatform()" class="py-5"></div>
  </footer>
</template>

<script setup lang="ts">
import sfzLogo from '~/assets/img/sfz_logo.svg'
import bmbfLogo from '~/assets/img/bmbf_logo.svg'
import prototypefundLogo from '~/assets/img/prototypefund_logo.svg'
import { Capacitor } from '@capacitor/core'
</script>

<style lang="scss">
.sponsors {
  width: fit-content;
}
</style>
